const de = {
    common: {
        appName: "LearnOS",
        signIn: "Anmelden",
        startFree: "Kostenlos starten",
        getStarted: "Loslegen",
        tryFree: "Kostenlos testen",
        watchDemo: "Demo ansehen",
        seeInAction: "LearnOS in Aktion sehen",
        cancel: "Abbrechen",
        delete: "Löschen",
        retry: "Erneut versuchen",
        loading: "Wird geladen…",
        included: "Enthalten",
        comingSoon: "Demnächst",
        placeholder: "Platzhalter",
    },
    nav: {
        problem: "Problem",
        howItWorks: "So funktioniert's",
        features: "Funktionen",
        tour: "Tour",
        testimonials: "Stimmen",
        modes: "Lesemodi",
        rewards: "Prämien",
        groupLibrary: "Bibliothek",
        groupLearn: "Lernen",
        groupAccount: "Konto",
        workspaces: "Workspaces",
        library: "Bibliothek",
        analytics: "Analysen",
        learnDashboard: "Lern-Dashboard",
        flashcards: "Karteikarten",
        review: "Wiederholen",
        examMode: "Prüfungsmodus",
        profile: "Profil",
        signOut: "Abmelden",
        tagline: "schneller lernen",
        brandTag: "AI Learning OS",
        language: "Sprache",
        groupEarn: "Programm",
        ambassador: "Botschafter",
        admin: "Admin",
        pricing: "Preise",
        upgrade: "Upgrade",
    },
    landing: {
        heroBadge: "Dein persönlicher KI-Tutor",
        heroTitle1: "Lade alles hoch.",
        heroTitle2: "Lerne alles.",
        heroSubtitle: "LearnOS ist kein PDF-Reader. Es verwandelt jedes Buch, PDF oder Skript in Zusammenfassungen, Karteikarten, Quizze und Prüfungssimulationen — geführt von einem persönlichen KI-Tutor, der dir hilft, mehr zu behalten und deine Prüfungen zu bestehen.",
        heroModesLabel: "4 integrierte Lesemodi",
        heroModes: [
            { name: "RSVP", tag: "Wort für Wort" },
            { name: "Ticker", tag: "Teleprompter-Fluss" },
            { name: "Geführt", tag: "Highlight führt dich" },
            { name: "Fokus", tag: "Ablenkungsfrei" },
        ],
        trust1: "Keine Kreditkarte",
        trust2: "Jedes PDF, Buch oder Skript",
        trust3: "Kostenlos starten",
        problem: {
            label: "Das Problem",
            title: "Lernen hat sich seit Jahrzehnten nicht verändert.",
            body: "Menschen lesen immer noch Hunderte Seiten, markieren, vergessen das meiste und pauken vor Prüfungen. Das Ergebnis: verschwendete Zeit, schlechte Merkfähigkeit und ständige Frustration.",
            cards: [
                { title: "Hunderte Seiten lesen", desc: "Stundenlanges passives Lesen mit wenig Ertrag." },
                { title: "Markieren & vergessen", desc: "Markieren fühlt sich produktiv an — hilft dem Gedächtnis aber kaum." },
                { title: "Pauken & Panik", desc: "Last-Minute-Pauken, das wenige Tage nach der Prüfung verblasst." },
            ],
        },
        solution: {
            label: "Die Lösung",
            title: "Lerne deinen persönlichen KI-Tutor kennen.",
            body: "LearnOS hilft dir nicht nur beim Lesen. Es hilft dir, zu verstehen, zu behalten und Wissen anzuwenden — automatisch.",
            pillars: [
                { title: "Verstehen", desc: "Die KI zerlegt komplexes Material in Ideen, die du wirklich begreifst." },
                { title: "Behalten", desc: "Aktives Erinnern und verteiltes Wiederholen verankern Wissen dauerhaft." },
                { title: "Anwenden", desc: "Quizze, Prüfungen und Coaching machen aus Wissen echtes Können." },
            ],
        },
        journey: ["Hochladen", "KI-Zusammenfassung", "Lesemodi", "Chat", "Karteikarten", "Quiz", "Prüfungsmodus", "Wissenslücken", "KI-Coach", "Meisterschaft"],
        how: {
            label: "So funktioniert's",
            title: "Vom Dokument zur Meisterschaft in vier Schritten",
            step: "Schritt",
            steps: [
                { title: "Beliebige Inhalte hochladen", desc: "Bücher, PDFs, Skripte, Berichte, Forschung — alles, was du lernen willst." },
                { title: "KI versteht den Inhalt", desc: "Erfasst Struktur, Kernideen, Definitionen und Zusammenhänge." },
                { title: "Smarter lernen", desc: "Karteikarten, Quizze, Prüfungssimulationen und aktives Erinnern." },
                { title: "Wissen meistern", desc: "Schwachstellen finden, Fortschritt verfolgen und mit einem KI-Coach besser werden." },
            ],
        },
        features: {
            label: "Funktionen",
            title: "Eine komplette KI-Lernplattform — kein bloßer Reader",
            body: "Zusammenfassungen, ein Tutor, Karteikarten, Quizze, Prüfungen, Lückenerkennung und Coaching — alles an einem Ort. Speed Reading ist nur ein Werkzeug darin.",
            items: [
                { title: "KI-Tutor", desc: "Dein persönlicher Tutor für jedes Dokument — frag alles und erhalte Antworten direkt aus der Quelle." },
                { title: "KI-Zusammenfassungen", desc: "1-Minuten-, 5-Minuten- und ausführliche Zusammenfassungen von allem, sofort." },
                { title: "Chat mit Dokumenten", desc: "Führe ein echtes Gespräch mit deinen Büchern und PDFs — mit Seitenangaben." },
                { title: "Karteikarten", desc: "Automatisch erstellte Karten, mit denen du durch aktives Erinnern lernst." },
                { title: "Quiz-Generator", desc: "Teste dein Verständnis mit Quizzen aus deinem Material." },
                { title: "Prüfungsmodus", desc: "Prüfungssimulationen mit Zeitlimit, die sich echt anfühlen." },
                { title: "Erkennung von Wissenslücken", desc: "Entdecke genau, welche Themen du noch nicht verstehst." },
                { title: "Wissensextraktion", desc: "Kernkonzepte, Definitionen und Zusammenhänge werden automatisch herausgezogen." },
                { title: "KI-Coach", desc: "Persönliche Empfehlungen basierend auf deinem echten Fortschritt." },
                { title: "Lern-Analysen", desc: "Verfolge Merkfähigkeit, Meisterschaft und deine gesamte Lernreise." },
                { title: "Lesemodi", desc: "Lies, wie du willst: RSVP-, Ticker-, Geführt- und Fokus-Modus integriert." },
                { title: "Speed Reading", desc: "Inhalte deutlich schneller erfassen — ein Werkzeug im System." },
            ],
        },
        readingModes: {
            label: "Lesemodi",
            title: "Vier Arten zu lesen — integriert",
            body: "Die meisten Apps bieten eine Art zu lesen. LearnOS bietet vier, damit du den Modus zum Material passend wählst.",
            modes: [
                { name: "RSVP-Modus", desc: "Wörter einzeln in deinem Wunschtempo eingeblendet — schneller lesen mit weniger Augenbewegung." },
                { name: "Ticker-Modus", desc: "Text gleitet wie ein Teleprompter über eine feste Linie — gleichmäßiges, ruhiges Tempo." },
                { name: "Geführtes Lesen", desc: "Der Text bleibt stehen, während ein smartes Highlight dich hindurchführt — ruhig und natürlich." },
                { name: "Fokus-Lesen", desc: "Dimmt alles außer der aktuellen Zeile, damit du konzentriert und ablenkungsfrei bleibst." },
            ],
        },
        personas: {
            label: "Für dich gemacht",
            title: "Für Studierende, Berufstätige & lebenslange Lernende",
            items: [
                { title: "Studierende", desc: "Verwandle Vorlesungen und Lehrbücher in aktives Erinnern, Karteikarten und Quizze.", tags: ["Medizinstudium", "Jurastudium", "BWL-Studium"] },
                { title: "Prüfungsvorbereitung", desc: "Prüfungssimulationen, Lückenerkennung und ein KI-Coach für deine Schwachstellen.", tags: ["Staatsexamen", "Abschlussprüfungen", "Zertifikate"] },
                { title: "Berufstätige", desc: "Schneller weiterbilden und mehr aus dichtem Material behalten.", tags: ["Zertifizierungen", "Weiterbildung"] },
                { title: "Lebenslange Lernende", desc: "Schlauer lesen und wirklich behalten, was dir wichtig ist.", tags: ["Bücher", "Kurse", "Forschung"] },
            ],
        },
        comparison: {
            label: "Der Unterschied",
            title: "Klassisches Lernen vs. LearnOS",
            traditional: "Klassisch",
            traditionalFlow: "Lesen → Vergessen",
            traditionalBullets: ["Manuelles Markieren", "Pauken vor Prüfungen", "Geringe Langzeit-Merkfähigkeit"],
            learnos: "LearnOS",
            learnosFlow: "Lesen → Verstehen → Behalten → Meistern",
            learnosBullets: ["Anleitung durch KI-Tutor", "Aktives Erinnern + Wiederholung", "Fortschritt + Lückenerkennung"],
            positioningLabel: "Positionierung",
            positioningTitle: "Andere KI-Tools helfen beim Lesen. LearnOS hilft beim Bestehen.",
            positioning: [
                { from: "Ein Recherche-Assistent", to: "Ein persönlicher KI-Tutor" },
                { from: "Dokumente verstehen", to: "Prüfungen bestehen" },
                { from: "Informationen", to: "Langzeit-Merkfähigkeit" },
                { from: "Lesen", to: "Meisterschaft" },
                { from: "Dokumente verarbeiten", to: "Ein komplettes Lernsystem" },
            ],
        },
        tour: {
            label: "Interaktive Produkttour",
            title: "Klick dich durch die Reise",
            body: "Sieh, wie LearnOS aus einem einzigen Dokument einen persönlichen KI-Tutor macht.",
            steps: [
                { title: "PDF hochladen", caption: "Beginne mit einem beliebigen Dokument." },
                { title: "KI-Zusammenfassung erhalten", caption: "Verstehe die Kernideen in Minuten." },
                { title: "Fragen stellen", caption: "Chatte direkt mit deinem Material." },
                { title: "Karteikarten erstellen", caption: "Verwandle Informationen in Erinnerung." },
                { title: "Quiz machen", caption: "Teste, was du wirklich weißt." },
                { title: "Prüfung simulieren", caption: "Prüfungsübung mit Zeitlimit, die sich echt anfühlt." },
                { title: "Wissenslücken finden", caption: "Entdecke, was mehr Aufmerksamkeit braucht." },
                { title: "Mit KI-Coach verbessern", caption: "Erhalte persönliche Empfehlungen." },
            ],
        },
        social: {
            label: "Was Lernende sagen",
            title: "Geliebt von Menschen, die viel lernen",
            testimonials: [
                { role: "Studierende:r", quote: "Das hätte ich mir vor Jahren gewünscht — meine Lernzeit hat sich halbiert." },
                { role: "Medizinstudent:in", quote: "Die Ansicht der Wissenslücken zeigt mir genau, was ich vor Prüfungen wiederholen muss." },
                { role: "Jurastudent:in", quote: "Fälle in Übungen zu verwandeln hat die Prüfungsvorbereitung endlich strukturiert." },
                { role: "Unternehmer:in", quote: "Ich kann jedes Thema schnell lernen, ohne wichtige Details zu verlieren." },
                { role: "Berufstätige:r", quote: "Perfekt für Zertifizierungen — Quizze und Coaching halten mich konsequent." },
            ],
        },
        finalCta: {
            title: "Hör auf zu lesen. Fang an zu lernen.",
            body: "Werde Teil der nächsten Generation des KI-gestützten Lernens.",
        },
        ambassadorBlock: {
            label: "Student Ambassador Program",
            title: "Lade Freunde ein. Verdiene wiederkehrende Prämien.",
            body: "Wir investieren in unsere Community statt in teure Werbung. Teile LearnOS mit den Menschen um dich herum, verdiene wiederkehrende Prämien, während sie lernen, und werde Teil der Reise.",
            point1: "Wiederkehrende Prämien für jedes aktive Mitglied, das du bringst",
            point2: "Schalte kostenlose Pro- & Premium-Monate frei, während du wächst",
            point3: "Werde Teil der LearnOS-Reise — kein Verkäufer",
            cta: "Botschafter werden",
        },
        footer: { tagline: "hochladen · verstehen · behalten · meistern" },
    },
    preview: {
        onePlatform: "eine Plattform",
        step: "Schritt",
        upload: { drop: "PDF, EPUB ablegen oder Link einfügen", dragDrop: "Datei hierher ziehen", formats: "PDF · EPUB · DOCX · TXT · URL", parsed: "Verarbeitet", parsing: "Wird verarbeitet…" },
        summary: { label5: "5-Min-Zusammenfassung", title5: "5-Minuten-Zusammenfassung", bullets: ["Die Kernthese in einem Satz.", "Drei Kräfte, die das Ergebnis bestimmen.", "Was du morgen damit tust."], tourBullets: ["Lernen ist eine trainierbare Fähigkeit, kein festes Talent.", "Behalten entsteht durch aktives Erinnern und verteiltes Üben, nicht durch erneutes Lesen.", "Kleine, regelmäßige Einheiten schlagen gelegentliches Pauken."], terms: ["Aufbau", "Behalten", "Erinnern"], ask: "Stelle eine Frage zu dieser Zusammenfassung" },
        speed: { wpm: "RSVP · 450 WPM", oneFeature: "eines von vielen Werkzeugen" },
        chat: { q1: "Was ist das Hauptargument?", a1: "Konsequentes kleines Üben summiert sich zu Meisterschaft.", tourQ1: "Was ist der größte Faktor für das Behalten?", tourA1: "Aktives Erinnern — dich selbst abfragen statt erneut zu lesen. Kombiniert mit Wiederholung am stärksten.", tourQ2: "Gib mir 3 Fragen zum Selbsttest." },
        flashcard: { question: "Frage", answer: "Antwort", q: "Was ist verteiltes Wiederholen?", a: "Material in zunehmenden Abständen wiederholen, um die Vergessenskurve zu bekämpfen.", tapReveal: "Tippe auf die Karte, um die Antwort zu zeigen", rate: "Erinnerung bewerten: Nochmal · Gut · Einfach", activeRecall: "Aktives Erinnern", card: "Karte" },
        quiz: { q: "Was steigert das Behalten am meisten?", tourQ: "Welche Methode verbessert das langfristige Behalten am meisten?", options: ["Erneut lesen", "Aktives Erinnern", "Markieren"], tourOptions: ["Das Kapitel erneut lesen", "Aktives Erinnern + Wiederholung", "Schlüsselsätze markieren"], question: "Frage", pick: "Wähle eine Antwort für sofortiges Feedback", correct: "Richtig — aktives Erinnern + Wiederholung gewinnt.", wrong: "Nicht ganz — aktives Erinnern + Wiederholung ist am besten." },
        gaps: { need: "Themen zum Wiederholen", needMore: "Themen brauchen mehr Aufmerksamkeit", confident: "sicher", topics: ["Aufbau-Intervalle", "Timing des Erinnerns"], tourTopics: ["Aufbau-Intervalle", "Erinnern vs. Wiedererkennen", "Optimale Lerndauer"], reviewNow: "Schwache Themen jetzt wiederholen" },
        coach: { todayPlan: "Heutiger Plan", yourPlan: "Dein Plan für heute", items: ["8 fällige Karten wiederholen", "Quiz: Aufbau-Intervalle (10 Min)"], tourItems: ["8 fällige Karten wiederholen (≈ 6 Min)", "Quiz: Aufbau-Intervalle", "1 Abschnitt zur Lerndauer lesen"], streakLine: "Die nächste Einheit hält deine 12-Tage-Serie am Leben" },
        exam: { mock: "Prüfungssimulation", timeLeft: "Restzeit", q: "Frage 4 / 20", prompt: "Welche Methode bringt das stärkste Langzeit-Behalten?", options: ["Notizen erneut lesen", "Aktives Erinnern auf Zeit", "Schlüsselzeilen markieren"], submit: "Prüfung abgeben", graded: "Automatisch bewertet · sofortiges Ergebnis" },
        mastery: { streak: "12-Tage-Serie", mastered: "124 Karten gemeistert", retention: "Behalten 86%" },
    },
    auth: {
        login: {
            title: "Willkommen zurück",
            subtitle: "Melde dich an, um weiterzulernen.",
            email: "E-Mail",
            emailPlaceholder: "du@beispiel.com",
            password: "Passwort",
            passwordPlaceholder: "Dein Passwort",
            submit: "Anmelden",
            demo: "Demo-Konto verwenden",
            noAccount: "Noch kein Konto?",
            signUp: "Registrieren",
            invalid: "Ungültige E-Mail oder Passwort",
            welcome: "Willkommen zurück!",
        },
        register: {
            title: "Konto erstellen",
            subtitle: "Beginne heute, schneller zu lesen und zu lernen.",
            name: "Name",
            namePlaceholder: "Ada Lovelace",
            email: "E-Mail",
            emailPlaceholder: "du@beispiel.com",
            password: "Passwort",
            passwordPlaceholder: "Mindestens 6 Zeichen",
            submit: "Konto erstellen",
            haveAccount: "Bereits ein Konto?",
            signIn: "Anmelden",
            pwShort: "Das Passwort muss mindestens 6 Zeichen haben",
            created: "Konto erstellt — willkommen!",
            failed: "Konto konnte nicht erstellt werden",
            invitedBy: "{name} hat dich zu LearnOS eingeladen",
            refApplied: "Botschafter-Einladung übernommen",
        },
    },
    rset: {
        title: "Leseeinstellungen",
        subtitle: "Bewegung, Darstellung und Hervorhebung anpassen",
        movement: "Bewegung",
        display: "Darstellung",
        highlight: "Hervorhebung",
        granularity: "Einheit",
        grain: { word: "Wort", phrase: "Phrase", sentence: "Satz" },
        autoScroll: "Auto-Scroll",
        dim: "Rest abdunkeln",
        readingFocus: "Lesefokus",
        focusMode: { minimal: "Minimal", word: "Aktives Wort", trail: "Lichtspur" },
        trailLength: "Spurlänge",
        trailLen: { short: "Kurz", medium: "Mittel", long: "Lang" },
        textAlign: "Textausrichtung",
        alignLeft: "Links",
        alignJustify: "Blocksatz",
        theme: "Modus",
        font: "Schriftart",
        fontNote: { dyslexia: "Legasthenie", sans: "Sans", serif: "Serif" },
        size: "Größe",
        width: "Textbreite",
        wNarrow: "Schmal",
        wStandard: "Standard",
        wWide: "Breit",
        lineHeight: "Zeilenabstand",
        lhCompact: "Kompakt",
        lhStandard: "Standard",
        lhAiry: "Luftig",
        reset: "Auf Standard zurücksetzen",
        activeWord: "Aktives Wort",
        activeWordHint: "Nur die Textfarbe des aktuell gelesenen Wortes ändert sich – kein Kasten.",
        wordAnchor: "Wort-Anker",
        anchor: { off: "Aus", "2": "2", "3": "3", "4": "4", "2l": "2 + letzter", "3l": "3 + letzter", auto: "Auto" },
        intensity: "Intensität",
        smartHighlights: "KI Smart Highlights",
        analyzing: "Dokument wird analysiert …",
        noHighlightsYet: "Für dieses Dokument wurden noch keine AI Smart Highlights erstellt.",
        noHighlights: "Keine Highlights gefunden.",
        generate: "AI Smart Highlights generieren",
        guidedDesc: "Farbspur führt dein Tempo · ganzer Text bleibt sichtbar",
        focusDesc: "Aktiver Satz im Fokus · Rest dezent gedimmt",
        smartHint: "Die KI hebt die wichtigsten Stellen hervor. Wähle unten, was markiert wird.",
        presets: {
            label: "Schnellauswahl",
            hint: "Ein Klick kombiniert die passenden Highlight-Ebenen.",
            custom: "Eigene",
            recommend: "Empfohlen für dieses Dokument",
            apply: "Übernehmen",
            firstReading: "Erste Lektüre",
            revision: "Wiederholung",
            medical: "Medizin-Examen",
            law: "Jura-Examen",
            business: "BWL-Examen",
        },
        domainLabel: { medical: "Medizinische Begriffe", legal: "Juristische Begriffe", business: "Wirtschaftsbegriffe" },
        hlCat: {
            definitions: { label: "Definitionen", desc: "Begriffe, die im Text definiert werden – das Fundament zum Verstehen.", style: "Türkis, durchgehende Linie" },
            concepts: { label: "Kernkonzepte", desc: "Zentrale Ideen, um die sich das Thema dreht.", style: "Blau, gestrichelte Linie" },
            exam_relevant: { label: "Prüfungsrelevant", desc: "Fakten, die in Prüfungen häufig abgefragt werden.", style: "Bernstein, kräftig gefüllt" },
            entities: { label: "Entitäten", desc: "Namen, Orte, Organisationen und Eigennamen.", style: "Magenta, gepunktete Linie" },
            domain: { label: "Fachbegriffe", desc: "Fachtypische Begriffe deines Fachgebiets.", style: "Grün, doppelte Unterstreichung" },
            numbers: { label: "Daten & Zahlen", desc: "Datumsangaben, Mengen, Dosierungen und Kennzahlen.", style: "Cyan, durchgehende Linie" },
            keywords: { label: "KI-Schlüsselwörter", desc: "Weitere von der KI erkannte Schlüsselwörter.", style: "Grauer Rahmen" },
        },
    },
    workspace: {
        hubTitle: "Deine Workspaces",
        hubSubtitle: "Bündle mehrere Quellen zu einem Fach – dein KI-Professor kennt sie alle gleichzeitig.",
        new: "Neuer Workspace",
        defaultName: "Meine Bibliothek",
        home: "Start",
        backToHub: "Zurück zu den Workspaces",
        emptyTitle: "Erstelle deinen ersten Workspace",
        emptyBody: "Ein Workspace vereint Vorlesungen, Bücher, Leitlinien und eigene Notizen zu EINER Wissensbasis. Chatte, fasse zusammen und prüfe dich über alle Quellen hinweg.",
        sourcesTitle: "Quellen in diesem Workspace",
        sourcesEmptyTitle: "Noch keine Quellen",
        sourcesEmptyBody: "Lade ein Dokument hoch oder füge eine bestehende Quelle aus deiner Bibliothek hinzu, um loszulegen.",
        quizMode: "Quiz",
        examMode: "Prüfung",
        loadFailed: "Workspaces konnten nicht geladen werden.",
        card: {
            sources: "{n} Quellen",
            cards: "{n} Karten",
            edit: "Bearbeiten",
            delete: "Löschen",
            deleteTitle: "Workspace löschen?",
            deleteBody: "Der Workspace wird gelöscht. Deine Quellen gehen NICHT verloren – sie werden in deine Bibliothek verschoben.",
            deleteConfirm: "Löschen",
            deleted: "Workspace gelöscht",
            deleteFailed: "Workspace konnte nicht gelöscht werden.",
        },
        tabs: {
            chat: "Chat",
            compare: "Vergleich",
            summary: "Zusammenfassung",
            cards: "Karteikarten",
            quiz: "Quiz & Prüfung",
            sources: "Quellen",
        },
        chat: {
            title: "KI-Professor",
            acrossSources: "über {n} Quellen",
            empty: "Frag deinen KI-Professor etwas – er kennt alle Quellen in diesem Workspace gleichzeitig.",
            placeholder: "Stelle eine Frage über alle Quellen …",
            needSource: "Füge zuerst mindestens eine fertige Quelle hinzu.",
            suggestions: ["Fasse die Kernkonzepte zusammen", "Wo widersprechen sich die Quellen?", "Erstelle eine Prüfungs-Checkliste"],
        },
        compare: {
            title: "Quellenübergreifende Analyse",
            intro: "Vergleiche alle Quellen: Worin sind sie sich einig, wo ergänzen sie sich, wo widersprechen sie sich – und welche Quelle erklärt was am besten.",
            needTwo: "Füge mindestens zwei fertige Quellen hinzu, um sie zu vergleichen.",
            analyze: "Quellen analysieren",
            reanalyze: "Neu analysieren",
            done: "Analyse abgeschlossen",
            failed: "Analyse fehlgeschlagen.",
            outdated: "Es wurden Quellen geändert – analysiere neu für ein aktuelles Ergebnis.",
            consensus: "Konsens",
            complementary: "Ergänzend",
            contradictions: "Widersprüche",
            noContradictions: "Keine echten Widersprüche zwischen den Quellen gefunden.",
            coverage: "Was jede Quelle am besten erklärt",
            gaps: "Lücken",
            studyPlan: "Lernempfehlung",
        },
        summary: {
            title: "Vereinte Zusammenfassung",
            empty: "Erstelle eine einheitliche Zusammenfassung über alle Quellen dieses Workspaces.",
            generate: "Zusammenfassung erstellen",
            regenerate: "Neu erstellen",
            failed: "Zusammenfassung fehlgeschlagen.",
            types: { student: "Student", five_min: "5 Min", one_min: "1 Min", fifteen_min: "15 Min", executive: "Executive", action: "Action" },
        },
        create: {
            title: "Neuer Workspace",
            editTitle: "Workspace bearbeiten",
            nameLabel: "Name",
            namePlaceholder: "z. B. Neurologie Sommersemester",
            descLabel: "Beschreibung (optional)",
            descPlaceholder: "Worum geht es in diesem Workspace?",
            iconLabel: "Symbol",
            colorLabel: "Farbe",
            createBtn: "Erstellen",
            saveBtn: "Speichern",
            created: "Workspace erstellt",
            updated: "Workspace aktualisiert",
            failed: "Workspace konnte nicht gespeichert werden.",
            nameRequired: "Bitte gib einen Namen ein.",
        },
        addSource: {
            button: "Aus Bibliothek",
            title: "Quelle hinzufügen",
            search: "Dokumente durchsuchen …",
            add: "Hinzufügen",
            added: "{title} hinzugefügt",
            failed: "Quelle konnte nicht hinzugefügt werden.",
            inWorkspace: "Im Workspace",
            none: "Keine Dokumente gefunden.",
        },
    },
    library: {
        morning: "Guten Morgen",
        afternoon: "Guten Tag",
        evening: "Guten Abend",
        subtitle: "Deine Wissensbibliothek — {count} {items}.",
        itemOne: "Eintrag",
        itemOther: "Einträge",
        continueReading: "Weiterlesen",
        allDocuments: "Alle Dokumente",
        search: "Titel suchen…",
        sortRecent: "Neueste",
        sortTitle: "Titel A–Z",
        sortProgress: "Fortschritt",
        sortLength: "Länge",
        emptyTitle: "Deine Bibliothek ist leer",
        emptyBody: "Lade ein PDF, EPUB, DOCX hoch oder füge einen Link ein — oder teste ein Beispiel und sieh die Magie in 30 Sekunden.",
        trySample: "Beispiel testen",
        noMatch: "Keine Dokumente passen zu „{query}“.",
        loadFailed: "Bibliothek konnte nicht geladen werden",
        deleted: "Gelöscht",
        deleteFailed: "Löschen fehlgeschlagen",
        sampleAdded: "Beispiel hinzugefügt — lass es uns zusammen lesen",
        sampleFailed: "Beispiel konnte nicht geladen werden",
        processingReady: "„{title}“ ist bereit zum Lesen",
        processingFailed: "Ein Dokument konnte nicht verarbeitet werden",
    },
    upload: {
        addContent: "Inhalt hinzufügen",
        title: "Zur Bibliothek hinzufügen",
        tabFile: "Datei",
        tabUrl: "URL",
        tabText: "Text",
        dropTitle: "Datei ablegen oder klicken zum Auswählen",
        dropHint: "PDF, EPUB, DOCX, TXT, MD · bis zu 100 MB",
        urlLabel: "Artikel-/Webseiten-URL",
        urlPlaceholder: "https://beispiel.com/artikel",
        importArticle: "Artikel importieren",
        titleLabel: "Titel (optional)",
        titlePlaceholder: "Meine Notizen",
        pasteLabel: "Text einfügen",
        pastePlaceholder: "Füge hier beliebigen Inhalt ein…",
        addText: "Text hinzufügen",
        added: "„{title}“ hinzugefügt",
        imported: "„{title}“ importiert",
        processing: "„{title}“ hochgeladen — Text wird im Hintergrund extrahiert…",
        uploadFailed: "Upload fehlgeschlagen",
        urlFailed: "URL konnte nicht importiert werden",
        textFailed: "Text konnte nicht hinzugefügt werden",
        pasteMore: "Bitte füge mehr Text ein",
    },
    card: {
        resume: "Fortsetzen",
        read: "Lesen",
        reread: "Erneut lesen",
        study: "Lernen & behalten",
        processing: "Wird verarbeitet…",
        processingHint: "Text wird extrahiert — große Dateien dauern einen Moment.",
        ocrHint: "Gescanntes Dokument — Seiten werden per KI gelesen…",
        ocrProgress: "KI liest Seite {done} von {total}…",
        failed: "Fehlgeschlagen",
        failedHint: "Diese Datei konnte nicht verarbeitet werden. Bitte erneut hochladen.",
        retrying: "Erneuter Versuch — Text wird wieder extrahiert…",
        deleteTitle: "Dieses Dokument löschen?",
        deleteBody: "Dies entfernt das Dokument und seinen Lesefortschritt dauerhaft.",
        deleteConfirm: "Löschen",
        cancel: "Abbrechen",
    },
    profile: {
        title: "Profil",
        subtitle: "Verwalte dein Konto und deinen Plan.",
        signOut: "Abmelden",
        planSuffix: "Plan",
        library: "Bibliothek",
        hours: "Stunden",
        streak: "Serie",
        plans: "Pläne",
        current: "aktuell",
        language: "Sprache",
        languageHelp: "Wähle die Sprache für die Oberfläche und neue KI-Inhalte.",
        viewPlans: "Pläne & Preise ansehen",
        manageBilling: "Abrechnung verwalten",
        upgradeCta: "Unbegrenztes Lernen freischalten",
        upgradeBody: "Upgrade auf Pro oder Premium für unbegrenzte Uploads, KI und Prüfungstools.",
        tiers: [
            { name: "Free", desc: "Erlebe den Mehrwert", features: ["Begrenzte Uploads", "KI-Zusammenfassungen", "Basis-Speed-Reading"] },
            { name: "Pro", desc: "Für die meisten Studierenden & Profis", features: ["Alles unbegrenzt", "Prüfungsmodus", "KI-Coach"] },
            { name: "Premium", desc: "Der komplette KI-Tutor", features: ["Erweiterte Merkfähigkeit", "Erkennung von Wissenslücken", "Priorisierte KI"] },
        ],
    },
    pricing: {
        badge: "Preise",
        title: "Wähle deinen Lernplan",
        subtitle: "Starte kostenlos. Upgrade, wenn du ohne Grenzen lernen willst.",
        perMonth: "/ Monat",
        free: "Free",
        mostPopular: "Am beliebtesten",
        completeTutor: "Der komplette KI-Tutor",
        currentPlan: "Aktueller Plan",
        cancelAnytime: "Jederzeit kündbar",
        plusPrevious: "Alles aus Pro, plus:",
        backToApp: "Zurück zur App",
        cta: { startFree: "Kostenlos starten", upgradePro: "Upgrade auf Pro", upgradePremium: "Upgrade auf Premium", current: "Dein aktueller Plan", signInToUpgrade: "Zum Upgrade anmelden" },
        notConfigured: { title: "Abrechnung noch nicht konfiguriert", body: "Zahlungen gehen bald live. Erkunde jetzt alle Pläne — der sichere Checkout öffnet, sobald die Abrechnung aktiv ist." },
        states: { processing: "Zahlung wird bestätigt…", success: "Willkommen an Bord! Dein Plan ist jetzt aktiv.", cancelled: "Checkout abgebrochen — es wurde nichts berechnet." },
        tiers: {
            free: { name: "Free", tagline: "Erlebe den Mehrwert", features: ["Begrenzte Uploads", "KI-Zusammenfassungen", "Basis-Speed-Reading", "Begrenzter Chat mit Dokumenten", "Begrenzte Karteikarten", "Begrenzte Quizze", "Basis-Analysen"] },
            pro: { name: "Pro", tagline: "Für die meisten Studierenden & Profis", features: ["Unbegrenzte Uploads", "Unbegrenzte KI-Zusammenfassungen", "Unbegrenztes Speed Reading", "Unbegrenzter Chat mit Dokumenten", "Unbegrenzte Wissensextraktion", "Vollständige Analysen", "Karteikarten", "Quiz-Generator", "Prüfungsmodus", "KI-Coach"] },
            premium: { name: "Premium", tagline: "Für ernsthafte Prüfungsvorbereitung", features: ["Erweiterte Merkfähigkeit", "Erkennung von Wissenslücken", "Erweiterter KI-Coach", "Priorisierte KI-Verarbeitung", "Lernpfade (bald)", "Kollaborationsfunktionen (bald)", "Lerngruppen (bald)", "Team-Funktionen (bald)"] },
        },
    },
    ambassador: {
        badge: "Botschafterprogramm",
        title: "LearnOS Botschafterprogramm",
        subtitle: "Wir investieren lieber in unsere Community als in teure Werbung. Teile LearnOS, hilf anderen beim Lernen — und werde belohnt.",
        note: "Du bist kein Verkäufer — du bist Teil der Reise. Danke, dass du LearnOS wachsen lässt.",
        yourCode: "Dein Einladungscode",
        yourLink: "Dein Einladungslink",
        copyCode: "Code kopieren",
        copyLink: "Link kopieren",
        copied: "In die Zwischenablage kopiert",
        howItWorks: "So funktioniert's",
        steps: [
            { title: "Teile deinen Link", desc: "Lade Freunde, Kommilitonen oder Kollegen zu LearnOS ein." },
            { title: "Sie lernen mit LearnOS", desc: "Wenn sie auf einen bezahlten Plan upgraden, werden sie ein aktives Mitglied." },
            { title: "Du wirst belohnt", desc: "Verdiene wiederkehrende Prämien und schalte kostenlose Monate frei." },
        ],
        stats: { total: "Insgesamt eingeladen", active: "Aktive Mitglieder", pending: "Ausstehend" },
        rewardsTitle: "Deine Prämien",
        perReferral: "{amount} € pro aktivem Mitglied / Monat",
        estimate: "Geschätzt monatlich",
        approved: "Genehmigt monatlich",
        paidOut: "Gesamt ausgezahlt",
        pendingReview: "Wartet auf Prüfung",
        milestonesTitle: "Prämien-Meilensteine",
        earned: "Erreicht",
        locked: "Gesperrt",
        proMonth: "1 Monat Pro gratis",
        premiumMonth: "1 Monat Premium gratis",
        milestoneProgress: "{count} / {target} aktive Mitglieder",
        nextReward: "Noch {remaining} aktive Mitglieder für {reward}",
        allUnlocked: "Fantastisch — du hast alle Meilensteine erreicht!",
        membersTitle: "Deine eingeladenen Mitglieder",
        member: "Mitglied",
        status: "Status",
        joined: "Beigetreten",
        membersEmpty: "Noch keine Einladungen. Teile deinen Link, um zu starten.",
        statuses: { pending: "Ausstehend", active: "Aktiv", rejected: "Abgelehnt" },
        payoutsTitle: "Deine Auszahlungen",
        payoutsEmpty: "Noch keine Auszahlungen — teile weiter!",
        amount: "Betrag",
        period: "Zeitraum",
    },
    admin: {
        title: "Admin",
        subtitle: "LearnOS Betriebszentrale.",
        notAuthorizedTitle: "Kein Zugriff",
        notAuthorizedBody: "Du hast keinen Zugriff auf den Admin-Bereich.",
        tabs: { overview: "Übersicht", users: "Nutzer", referrals: "Empfehlungen", payouts: "Auszahlungen" },
        overview: { totalUsers: "Nutzer gesamt", free: "Free", pro: "Pro", premium: "Premium", paying: "Zahlend", mrr: "Geschätzter MRR", referrals: "Empfehlungen", activeReferrals: "Aktiv", growth: "Empfehlungswachstum · 14 Tage", topAmbassadors: "Top-Botschafter", noAmbassadors: "Noch keine Botschafter.", pendingPayouts: "Offene Auszahlungen", activeMembers: "aktiv" },
        users: { search: "Nach Name, E-Mail oder Code suchen…", name: "Name", email: "E-Mail", plan: "Plan", paying: "Zahlend", joined: "Beigetreten", actions: "Aktionen", markPaying: "Als zahlend markieren", unmark: "Aufheben", yes: "Ja", no: "Nein", updated: "Nutzer aktualisiert", empty: "Keine Nutzer gefunden.", createPayout: "Auszahlung erstellen" },
        referrals: { ambassador: "Botschafter", member: "Mitglied", status: "Status", commission: "Provision", actions: "Aktionen", approve: "Genehmigen", reject: "Ablehnen", updated: "Empfehlung aktualisiert", empty: "Noch keine Empfehlungen.", filterAll: "Alle", filterActive: "Aktiv", filterPending: "Ausstehend" },
        payouts: { ambassador: "Botschafter", amount: "Betrag", period: "Zeitraum", status: "Status", actions: "Aktionen", approve: "Genehmigen", markPaid: "Als bezahlt markieren", reject: "Ablehnen", created: "Auszahlung erstellt", updated: "Auszahlung aktualisiert", empty: "Noch keine Auszahlungen." },
        commissionStatus: { none: "Keine", eligible: "Berechtigt", approved: "Genehmigt", rejected: "Abgelehnt" },
        payoutStatus: { pending: "Ausstehend", approved: "Genehmigt", paid: "Bezahlt", rejected: "Abgelehnt" },
    },
    billing: {
        notConfigured: "Abrechnung noch nicht konfiguriert",
        comingSoon: "Abrechnung bald verfügbar",
        manage: "Abrechnung verwalten",
        viewPlans: "Pläne ansehen",
        upgrade: "Upgrade",
    },
    explain: {
        title: "Schnell erklärt",
        loading: "Wird verstanden…",
        error: "Konnte das gerade nicht erklären.",
        retry: "Erneut versuchen",
        definition: "Definition",
        simply: "Einfach erklärt",
        whyMatters: "Warum es wichtig ist",
        examRelevance: "In Prüfungen",
        memoryTip: "Merk-Tipp",
        related: "Verwandte Begriffe",
        inPassage: "In dieser Textstelle",
        save: "Speichern",
        saved: "Gespeichert",
        note: "Notiz",
        notePlaceholder: "Notiz zu diesem Begriff hinzufügen…",
        noteSaved: "Notiz gespeichert",
        saveNote: "Notiz speichern",
        flashcard: "Karteikarte",
        addedFlashcard: "Zu Karteikarten hinzugefügt",
        askAI: "KI fragen",
        revisited: "{n}× nachgeschlagen",
        askQuestion: "Erkläre dieses Konzept im Kontext dieses Dokuments: „{term}“",
        selectionHint: "Markiere beliebigen Text, um ihn zu erklären",
    },
    learningProfile: {
        title: "Begriffe, die du erkundest",
        subtitle: "Begriffe, die du beim Lesen nachgeschlagen hast. Wiederhole die, die immer wiederkehren.",
        empty: "Klicke beim Lesen auf einen hervorgehobenen Begriff für eine sofortige Erklärung. Deine erkundeten Konzepte erscheinen hier.",
        saved: "{n} gespeicherte Begriffe",
        revisit: "evtl. wiederholen",
        frequently: "Häufig nachgeschlagen",
        suggestedReview: "Zur Wiederholung vorgeschlagen",
    },
    glossary: {
        nav: "Mein Glossar",
        title: "Mein Glossar",
        subtitle: "Deine persönliche Konzept-Bibliothek — jeder Begriff, den du beim Lesen gespeichert hast.",
        count: "{n} Konzepte",
        search: "Konzepte, Notizen, Dokumente durchsuchen…",
        filters: { all: "Alle", recent: "Zuletzt gespeichert", revisited: "Meist nachgeschlagen", review: "Zu wiederholen", understood: "Verstanden", flashcards: "In Karteikarten" },
        allDocuments: "Alle Dokumente",
        allDomains: "Alle Bereiche",
        status: { new: "Neu", review: "Wiederholen", understood: "Verstanden" },
        domain: { medical: "Medizin", legal: "Recht", business: "Wirtschaft", general: "Allgemein" },
        revisitsLabel: "{n}× nachgeschlagen",
        savedOn: "Gespeichert am {date}",
        inFlashcards: "In Karteikarten",
        fields: { definition: "Definition", simply: "Einfach erklärt", whyMatters: "Warum es wichtig ist", examRelevance: "In Prüfungen", memoryTip: "Merk-Tipp", related: "Verwandte Begriffe", source: "Quelle" },
        actions: { open: "Öffnen", openDoc: "Dokument öffnen", jump: "Zur Textstelle springen", ask: "KI fragen", addFlashcard: "Zu Karteikarten", added: "In Karteikarten", note: "Notiz", notePlaceholder: "Deine Notiz zu diesem Konzept…", saveNote: "Notiz speichern", remove: "Entfernen" },
        noteSaved: "Notiz gespeichert",
        statusUpdated: "Status aktualisiert",
        addedFlashcard: "Zu Karteikarten hinzugefügt",
        removed: "Aus Glossar entfernt",
        error: "Etwas ist schiefgelaufen.",
        empty: { title: "Baue deine persönliche Konzept-Bibliothek", body: "Speichere wichtige Begriffe beim Lesen — sie werden hier für die spätere Wiederholung gesammelt.", cta: "Dokument öffnen und loslegen" },
        noResults: "Keine Konzepte passen zu deinen Filtern.",
        tour: { title: "Mein Glossar", body: "Jedes Konzept, das du beim Lesen speicherst, wird hier zur späteren Wiederholung gesammelt — wiederholen, zu Karteikarten hinzufügen oder zur Quelle zurückspringen." },
    },
    onboarding: {
        badge: "Erste Schritte",
        skip: "Überspringen",
        back: "Zurück",
        next: "Weiter",
        finish: "Fertig",
        restart: "Tour neu starten",
        restartHelp: "Spiele die geführte Tour durch alle LearnOS-Funktionen erneut ab.",
        guide: "LearnOS-Guide",
        stepOf: "Schritt {c} von {total}",
        steps: [
            { title: "Willkommen bei LearnOS", body: "Dein persönlicher KI-Tutor. Lade deine eigenen Dokumente hoch und lerne schneller, verstehe mehr, behalte länger — und bestehe deine Prüfungen." },
            { title: "Starte, wie du willst", body: "Es gibt keinen falschen Weg. Wähle den Pfad, der zu deinem Lernstil passt — und wechsle jederzeit.", chips: ["KI-Zusammenfassung", "Chat", "Speed-Reading", "Karteikarten", "Quiz", "Prüfungsmodus"] },
            { title: "Bring dein eigenes Material mit", body: "Lade eine Datei hoch, füge einen Link ein oder kopiere Text hinein. LearnOS macht daraus einen interaktiven Lernraum.", chips: ["PDF", "EPUB", "DOCX", "TXT", "Website", "Text einfügen"] },
            { title: "Das Wichtigste in Sekunden", body: "Erstelle eine Zusammenfassung in der Tiefe, die du brauchst. Völlig optional — überspringe sie jederzeit.", chips: ["1 Min", "5 Min", "15 Min", "Executive", "Student", "Action"] },
            { title: "Fragen statt nur lesen", body: "Stelle deinem Dokument sofort Fragen — ganz ohne vorher zu lesen. Die KI versteht es bereits und antwortet mit Quellen.", chips: ["Welches Kapitel ist zentral?", "Erkläre dieses Konzept", "Gib mir Beispiele", "Vergleiche zwei Ideen"] },
            { title: "Lies auf deine Art", body: "Vier fokussierte Lesemodi, jederzeit umschaltbar. Speed-Reading ist nur eine Option — nie ein Muss.", chips: ["RSVP", "Ticker", "Geführt", "Fokus"] },
            { title: "Aufmerksamkeit, gelenkt", body: "Die KI hebt zentrale Konzepte, Definitionen, prüfungsrelevante Fakten und Schlüsselwörter hervor — damit dein Fokus dort landet, wo es zählt." },
            { title: "Jedes Konzept sofort verstehen", body: "Klicke auf eine Hervorhebung für eine einfache Erklärung, Prüfungsrelevanz, einen Merk-Tipp und verwandte Ideen — oder frage die KI und speichere es.", chips: ["Definition", "Einfach", "Prüfungsrelevanz", "Merk-Tipp", "KI fragen", "Speichern"] },
            { title: "Deine persönliche Konzept-Bibliothek", body: "Jedes gespeicherte Konzept liegt in „Mein Glossar“. Wiederhole später, füge Notizen hinzu, erstelle Karteikarten oder springe zurück zur Quelle." },
            { title: "Karteikarten, für dich gemacht", body: "Automatisch aus deinem Material erstellt und bereit für verteiltes Wiederholen — damit es wirklich hängen bleibt." },
            { title: "Teste dich selbst", body: "Erstelle Quizze aus deinen eigenen Dokumenten und prüfe, was du wirklich verstanden hast." },
            { title: "Übe wie im Ernstfall", body: "Trainiere realistische Prüfungen und finde die Bereiche, die noch Arbeit brauchen." },
            { title: "Persönliche Begleitung", body: "Dein KI-Coach gibt dir Lernempfehlungen, die zu deinem Fortschritt passen." },
            { title: "Wisse, was zu wiederholen ist", body: "LearnOS zeigt dir behutsam Konzepte, die noch einen Blick brauchen — aus deinem tatsächlichen Lernverhalten, nicht geraten." },
            { title: "Sieh deinen Fortschritt", body: "Verfolge Lesezeit, Geschwindigkeit, Fortschritt und deinen bevorzugten Lesemodus im Zeitverlauf." },
            { title: "Lass die Community wachsen", body: "Lade Freunde ein und verdiene wiederkehrende Prämien, während du LearnOS wachsen hilfst." },
            { title: "Passende Tarife", body: "Starte kostenlos und wechsle nur, wenn du mehr brauchst. Ganz ohne Druck.", chips: ["Free", "Pro", "Premium"] },
            { title: "Alles bereit", body: "Du musst nicht jede Funktion nutzen. Manche fassen nur zusammen und chatten; andere lesen schnell, üben Karteikarten oder machen Prüfungen. LearnOS passt sich dir an — erkunde und finde deinen eigenen Lernweg." },
        ],
    },
    reader: {
        back: "Zurück zur Bibliothek",
        words: "Wörter",
        loadFailed: "Dokument konnte nicht geladen werden",
        aiTools: "KI",
        modes: {
            rsvp: { label: "RSVP", hint: "RSVP-Modus – Wort-für-Wort-Speedreading" },
            ticker: { label: "Ticker", hint: "Ticker-Modus – gleitender Textstrom" },
            focus: { label: "Fokus", hint: "Fokus-Lesen – geführt, Zeile für Zeile" },
            guided: { label: "Geführt", hint: "Geführtes Lesen – die ganze Seite bleibt stehen, während ein KI-Lesehinweis dich hindurchführt" },
        },
    },
    panels: { summaries: "Zusammenfassungen", chat: "Chat", knowledge: "Wissen" },
    summaries: {
        title: "KI-Zusammenfassungen",
        auto: "Auto",
        generate: "{label}-Zusammenfassung erstellen",
        regenerate: "Neu erstellen",
        empty: "Wähle eine Länge, um dieses Dokument in Sekunden zu destillieren.",
        error: "Zusammenfassung konnte nicht erstellt werden",
        types: { one_min: "1 Min", five_min: "5 Min", fifteen_min: "15 Min", executive: "Executive", student: "Student", action: "Action" },
    },
    chat: {
        title: "Chat mit dem Buch",
        empty: "Frag alles über dieses Dokument. Antworten zitieren die genauen Textstellen.",
        placeholder: "Frage zu diesem Dokument stellen…",
        sending: "Quellen werden gelesen…",
        sendHint: "zum Senden",
        newlineHint: "Umschalt+Enter für neue Zeile",
        error: "Chat fehlgeschlagen",
        errorMsg: "_Entschuldige, das konnte ich nicht beantworten. Bitte versuche es erneut._",
        suggestions: [
            "Was ist die Kernaussage?",
            "Gib mir die wichtigsten Erkenntnisse.",
            "Wo wird die zentrale Idee behandelt?",
            "Hinterfrage das Argument des Autors.",
        ],
        quick: {
            simpler: "Einfacher erklären",
            deeper: "Tiefer gehen",
            examples: "Beispiele geben",
            examQ: "Prüfungsfrage erstellen",
            flashcard: "Als Karteikarte speichern",
        },
        quickPrompt: {
            simpler: "Erkläre deine letzte Antwort einfacher, in klaren, alltäglichen Worten.",
            deeper: "Geh bei deiner letzten Antwort mehr in die Tiefe – mit Details und Hintergrund.",
            examples: "Gib mir konkrete Beispiele zu deiner letzten Antwort.",
            examQ: "Formuliere eine typische Prüfungsfrage zu deiner letzten Antwort und beantworte sie kurz.",
        },
        card: {
            preview: "Vorschau der Karteikarte",
            creating: "Karteikarte wird erstellt …",
            front: "Vorderseite",
            back: "Rückseite",
            save: "Karteikarte speichern",
            cancel: "Abbrechen",
            saved: "Karteikarte gespeichert",
            duplicate: "Diese Karte gibt es bereits in deinem Deck.",
            failed: "Karteikarte konnte nicht erstellt werden.",
        },
    },
    overview: {
        button: "Übersicht",
        title: "Highlight-Übersicht",
        subtitle: "Alle markierten Stellen – zum Wiederholen und Anspringen.",
        all: "Alle",
        empty: "Noch keine Highlights zum Anzeigen. Aktiviere Ebenen oder generiere AI Smart Highlights.",
        count: "{n} Stellen",
        jump: "Zur Stelle springen",
        explain: "Erklären",
        noMatch: "Keine Treffer in dieser Kategorie.",
        position: "Position {n}%",
    },
    knowledge: {
        title: "Wissen",
        empty: "Extrahiere die wichtigsten Erkenntnisse, Aktionen, Zitate, Konzepte und Denkmodelle.",
        generate: "Wissen extrahieren",
        error: "Extraktion fehlgeschlagen",
        insights: "Kernerkenntnisse",
        actions: "Aktionspunkte",
        quotes: "Zitate",
        concepts: "Konzepte",
        models: "Denkmodelle",
    },
    learn: {
        title: "Lernen",
        subtitle: "Lesen → Verstehen → Behalten → Meistern.",
        dueTitle: "{n} Karten zur Wiederholung fällig",
        dueSubtitle: "Verteiltes Wiederholen verhindert, dass Wissen verblasst.",
        startReview: "Wiederholung starten",
        statFlashcards: "Karteikarten",
        statMastered: "Gemeistert",
        statQuizzes: "Quizze",
        statAvgQuiz: "Ø Quiz",
        growth: "Wissenszuwachs",
        states: { new: "Neu", learning: "Lernen", familiar: "Vertraut", mastered: "Gemeistert" },
        achievements: "Erfolge",
        masteryByDoc: "Meisterschaft je Dokument",
        masteryEmpty: "Lies ein Dokument und erstelle Karteikarten, um Meisterschaft aufzubauen.",
    },
    study: { mode: "Lernmodus", exam: "Prüfung", tabRecap: "Rückblick", tabFlashcards: "Karteikarten", tabQuiz: "Quiz", tabReflect: "Reflektieren", loadFailed: "Konnte nicht geladen werden" },
    examPage: { mode: "Prüfungsmodus", mockTitle: "Prüfung mit Zeitlimit", mockDesc: "Wird ausschließlich aus diesem Dokument erstellt. Die Prüfung wird automatisch abgegeben, wenn die Zeit abläuft.", loadFailed: "Konnte nicht geladen werden" },
    review: {
        title: "Wiederholung mit verteiltem Lernen",
        allCaughtTitle: "Alles erledigt!",
        allCaughtBody: "Aktuell sind keine Karten fällig. Erstelle weitere Karteikarten oder komm später wieder.",
        backToLearning: "Zurück zum Lernen",
        completeTitle: "Wiederholung abgeschlossen!",
        completeBodyGreat: "Du hast {n} Karten wiederholt. Starke Merkleistung!",
        completeBodyNeed: "Du hast {n} Karten wiederholt. {again} brauchen bald einen zweiten Blick.",
        loadFailed: "Wiederholungen konnten nicht geladen werden",
    },
    analytics: {
        title: "Lese-Analysen",
        subtitle: "Dein Lernmomentum auf einen Blick.",
        streak: "Serie",
        hoursRead: "Stunden gelesen",
        avgWpm: "Ø WPM",
        fastestWpm: "Schnellste WPM",
        inLibrary: "In der Bibliothek",
        completed: "Abgeschlossen",
        wordsRead: "Wörter gelesen",
        retention: "Behalten",
        daysSuffix: "Tage",
        hoursSuffix: "Std",
        wpmTrend: "WPM-Verlauf (14 Tage)",
        minutesTrend: "Gelesene Minuten (14 Tage)",
        readingStyle: "Lesestil",
        readingStyleDesc: "Welchen Lesemodus du tatsächlich am meisten nutzt.",
        prefers: "Bevorzugt {mode}",
        readingStyleEmpty: "Beginne in einem beliebigen Modus zu lesen, um deinen Stil hier zu sehen.",
        sessions: "Sitzungen",
        minShort: "Min",
        activity: "Aktivität (letzte 7 Wochen)",
        less: "weniger",
        more: "mehr",
        achievements: "Erfolge",
        badges: { first: "Erster Read", streak3: "3-Tage-Serie", fast: "Tempo 500+", finisher: "Finisher", scholar: "Gelehrter" },
    },
    docpicker: {
        study: { title: "Karteikarten", subtitle: "Wähle ein Buch, um Karteikarten zu erstellen und zu lernen.", emptyTitle: "Baue dein aktives Erinnern auf", emptyBody: "Karteikarten verwandeln jedes Dokument in verteiltes Wiederholen – der schnellste Weg, Wissen dauerhaft zu behalten. Füge ein Buch hinzu, um zu starten." },
        exam: { title: "Prüfungsmodus", subtitle: "Wähle ein Buch, um eine Prüfung mit Zeitlimit daraus zu schreiben.", emptyTitle: "Übe unter echten Bedingungen", emptyBody: "Prüfungssimulationen mit Zeitlimit aus deinem eigenen Material zeigen dir, ob du wirklich bereit bist. Füge ein Buch hinzu, um zu starten." },
        cards: "Karten",
        quizzes: "Quizze",
        ctaStudy: "Karten lernen",
        ctaExam: "Prüfung starten",
        goToLibrary: "Zur Bibliothek",
    },
    deck: {
        generate: "Karteikarten erstellen",
        generateMore: "Weitere Karten erstellen",
        generateBtn: "Erstellen",
        types: { basic: "F&A", concept: "Konzept", fill_blank: "Lückentext", reasoning: "Begründung" },
        cardTypes: "Kartentypen",
        difficulty: "Schwierigkeit",
        count: "Anzahl",
        diffs: { beginner: "Anfänger", intermediate: "Mittel", advanced: "Fortgeschritten" },
        pickType: "Wähle mindestens einen Kartentyp",
        created: "{n} Karteikarten erstellt",
        genFailed: "Erstellung fehlgeschlagen",
        cards: "Karten",
        studyThese: "Diese lernen",
        backToDeck: "Zurück zum Stapel",
        reviewComplete: "Wiederholungssitzung abgeschlossen",
        editTitle: "Karteikarte bearbeiten",
        front: "Vorderseite",
        back: "Rückseite",
        saved: "Gespeichert",
        saveFailed: "Speichern fehlgeschlagen",
        regenerated: "Karte neu erstellt",
        regenFailed: "Neu erstellen fehlgeschlagen",
    },
    quiz: {
        questionTypes: "Fragetypen",
        difficulty: "Schwierigkeit",
        questions: "Fragen",
        timeLimit: "Zeitlimit",
        startQuiz: "Quiz starten",
        startExam: "Prüfung starten",
        types: { mcq: "Multiple Choice", true_false: "Wahr / Falsch", open: "Offene Frage", scenario: "Szenario", case_study: "Fallstudie", exam: "Prüfungsfrage" },
        diffs: { beginner: "Anfänger", intermediate: "Mittel", advanced: "Fortgeschritten" },
        craftingQuiz: "Dein Quiz wird erstellt…",
        craftingExam: "Deine Prüfung wird erstellt…",
        question: "Frage {i} / {n}",
        answered: "{n} beantwortet",
        back: "Zurück",
        next: "Weiter",
        submit: "Abgeben",
        correctCount: "{correct} / {total} richtig",
        recommendedReview: "Empfohlene Wiederholung",
        noWeak: "Keine Schwachstellen – ausgezeichnet!",
        done: "Fertig",
        yourAnswer: "deine Antwort",
        feedback: "Feedback",
        modelAnswer: "Musterlösung",
        correctAnswer: "Richtige Antwort:",
        typeAnswer: "Gib deine Antwort ein…",
        trueLabel: "Wahr",
        falseLabel: "Falsch",
        genFailed: "Quiz-Erstellung fehlgeschlagen",
        submitFailed: "Abgabe fehlgeschlagen",
        score: "Punkte",
    },
    fcReview: {
        card: "Karte {i} / {n}",
        question: "Frage",
        answer: "Antwort",
        reveal: "Antwort zeigen",
        space: "(Leertaste)",
        hint: "Tipp",
        again: "Nochmal",
        hard: "Schwer",
        good: "Gut",
        easy: "Einfach",
    },
    coach: {
        title: "KI-Lerncoach",
        focusTopics: "Fokusthemen",
        nextSteps: "Nächste Schritte",
        empty: "Lies und wiederhole etwas mehr, dann hat dein Coach Erkenntnisse für dich.",
    },
    reflection: {
        intro: "Reflektieren, um zu behalten. In eigenen Worten zu schreiben steigert das Behalten enorm.",
        placeholder: "Schreibe deine Reflexion…",
        loadFailed: "Reflexionsfragen konnten nicht geladen werden",
    },
    scores: { reading: "Lesen", understanding: "Verstehen", retention: "Behalten", mastery: "Meisterschaft" },
    completion: {
        title: "Dokument abgeschlossen!",
        body: "Du hast {title} beendet.",
        faster: "Du hast es etwa {min} Min schneller gelesen als der Durchschnitt.",
        words: "Wörter",
        yourSpeed: "dein Tempo",
        timeSaved: "Zeit gespart",
        wpm: "WPM",
        min: "Min",
        studyToRemember: "Lernen, um zu behalten",
        readSummary: "Zusammenfassung lesen",
        ask: "Fragen",
        library: "Bibliothek",
    },
    achievements: {
        earned: "Erreicht",
        items: {
            first_book: { label: "Erstes Buch abgeschlossen", desc: "Beende dein erstes Dokument" },
            streak10: { label: "10-Tage-Serie", desc: "Lies 10 Tage in Folge" },
            cards100: { label: "100 Karten gemeistert", desc: "Meistere 100 Karten" },
            quiz90: { label: "90% Quiz-Ergebnis", desc: "Erreiche 90%+ in einem Quiz" },
            words100k: { label: "100.000 Wörter gelesen", desc: "Lies 100k Wörter" },
            builder: { label: "Wissens-Baumeister", desc: "Erstelle 50 Karteikarten" },
            fast_learner: { label: "Schnelllerner", desc: "Ø 400+ WPM" },
            master_reader: { label: "Meister-Leser", desc: "Erreiche 80% Meisterschaft in einem Dokument" },
        },
    },
    detail: {
        label: "Tiefe",
        quick: "Schnell", standard: "Standard", expert: "Experte",
        quickHint: "Kurz & direkt", standardHint: "Klar & strukturiert",
        expertHint: "Universitätsniveau – ausführlich, prüfungsorientiert",
    },
    pro: {
        deepDive: "Vertiefung",
        improve: "Verbessern", harder: "Schwerer machen",
        fromWeak: "Aus Schwächen lernen", fromWeakDesc: "Karten aus deinen schwachen Themen erstellen",
        noWeak: "Noch keine schwachen Themen – mach zuerst ein Quiz.",
        weakGenerated: "{n} Karten zu schwachen Themen erstellt",
        whatCorrect: "Das war richtig", whatMissing: "Das hat gefehlt", whatWrong: "Das war falsch",
        examinerNote: "Prüfer-Bewertung", howToImprove: "So wirst du besser",
        commonMistake: "Häufiger Fehler", advice: "Lerntipp",
    },
};

export default de;
